import React from 'react';
import clsx from 'clsx';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import TempoIcon from 'assets/svg/TempoIcon';

type Props = {
  className?: string;
  isCompleted?: boolean;
  label?: string;
  onStart: () => void;
  shouldShowAction?: boolean;
  startLabel?: string;
  subtitle?: string;
  title?: string;
};

const sectionContainerClassName = 'flex flex-1 flex-col rounded-3xl border border-populate-green/15 bg-[linear-gradient(180deg,rgba(21,184,166,0.08),rgba(255,255,255,0.96))] p-4 shadow-sm';
const sectionButtonClassName = 'relative mt-5 flex min-h-[112px] w-full items-center justify-center rounded-2xl border border-populate-green/15 bg-white px-5 py-6 text-gray-900 shadow-[0_10px_28px_rgba(21,184,166,0.10)] transition hover:bg-[#f8fffd] hover:shadow-[0_14px_32px_rgba(21,184,166,0.14)]';
const sectionCompletedClassName = 'relative mt-5 flex min-h-[112px] w-full items-center justify-center px-5 py-6 text-gray-900';
const completedPillClassName = 'inline-flex items-center rounded-full bg-[#dcf7f2] px-3 py-1 text-sm font-semibold text-populate-deep-green';

export function CompletedPill() {
  return (
    <span className={completedPillClassName}>Completed</span>
  );
}

export default function TempoCard({
  className,
  isCompleted = false,
  label,
  onStart,
  shouldShowAction = true,
  startLabel = 'Start screening',
  subtitle,
  title = 'Psych Screening',
}: Props) {
  const showAction = shouldShowAction || isCompleted;

  return (
    <div className={clsx('flex w-full flex-col', className)}>
      {label && (
        <div className="mb-4 flex items-center gap-3 px-1">
          <div className="h-px flex-1 bg-gray-200" />
          <div className="text-center text-sm text-gray-500">
            {label}
          </div>
          <div className="h-px flex-1 bg-gray-200" />
        </div>
      )}

      <div className={sectionContainerClassName}>
        <div className="flex-1 text-left">
          <h3 className="text-lg font-bold tracking-[-0.02em] text-gray-900">
            {title}
          </h3>
          <p className="mt-1 text-sm text-gray-600">
            {showAction ? subtitle : ''}
          </p>
        </div>

        {showAction && (
          isCompleted ? (
            <div className={sectionCompletedClassName}>
              <div className="flex flex-col items-center text-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-teal-50">
                  <CheckCircleOutlineRoundedIcon className="!text-populate-green !text-[22px]" />
                </div>
                <p className="text-lg font-bold tracking-[-0.01em]">
                  Completed
                </p>
              </div>
            </div>
          ) : (
            <button
              type="button"
              className={sectionButtonClassName}
              onClick={onStart}
            >
              <div className="flex flex-col items-center text-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-teal-50">
                  <TempoIcon className="!text-[22px] text-teal-600" />
                </div>
                <p className="text-lg font-bold tracking-[-0.01em]">
                  {startLabel}
                </p>
              </div>
            </button>
          )
        )}
      </div>
    </div>
  );
}
